// extracted by mini-css-extract-plugin
export var highlightFade = "_2k-4";
export var highlighted = "_2k-3";
export var table = "_2k-1";
export var tableContainer = "_2k-0";
export var totalsRow = "_2k-2";